module.exports = __webpack_public_path__ + "static/works-cafe86-mobile-035dc73b312d6d7c96cee833d12d5e20.png";